import * as React from "react";
import { Box, Typography } from "@material-ui/core";
import {
  Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon,
  HighlightOff as HighlightOffIcon,
} from "@material-ui/icons";

import theme from "theme";
import { circleIconSize } from "theme/constants";

interface StatusMessageProps {
  type: "success" | "failure" | "failureHollow";
  message: string;
  children?: React.ReactNode;
}

const StatusMessage: React.FC<StatusMessageProps> = ({
  message,
  type,
  children,
}) => {
  let image;
  switch (type) {
    case "success": {
      image = (
        <CheckCircleIcon
          style={{
            fontSize: circleIconSize.medium,
            color: theme.custom.palette.green.main,
          }}
        />
      );
      break;
    }
    case "failure": {
      image = (
        <CancelIcon
          style={{ fontSize: "4rem", color: theme.custom.palette.red.main }}
        />
      );
      break;
    }
    case "failureHollow": {
      image = (
        <HighlightOffIcon
          style={{ fontSize: "4rem", color: theme.custom.palette.red.main }}
        />
      );
      break;
    }
  }
  return (
    <div style={{ textAlign: "center" }}>
      <Box mb={2}>{image}</Box>
      <Box mb={2}>
        <Typography variant="body1">{message}</Typography>
      </Box>
      {children}
    </div>
  );
};

export default StatusMessage;
